// Shared by Zudoku mounts and the AI citation index.
export const apiFiles = [
  ['combined/wallet.yaml', 'wallet/api/rest-api'],
  ['combined/spot.yaml', 'core-trading-spot/api/rest-api'],
  ['combined/futures.yaml', 'core-trading-futures/api/rest-api'],
  ['combined/broker.yaml', 'vip-institutional-broker/api/rest-api'],
  ['combined/partner.yaml', 'vip-institutional-partner/api/rest-api'],
  ['combined/copy.yaml', 'advanced-trading-copy-trading/api/rest-api'],
  ['combined/futures-streams.yaml', 'core-trading-futures/api/ws-streams'],
  ['combined/spot-streams.yaml', 'core-trading-spot/api/ws-streams'],
];
